"use client"
/* */
import { jsx, jsxs } from 'react/jsx-runtime';
import { DataLoader } from './components/DataLoader/DataLoader.mjs';
import { Header } from './components/Header/Header.mjs';
import headerStyles from './components/Header/Header.module.css.mjs';
import { Items } from './components/Items/Items.mjs';
import { Table } from './components/Table/Table.mjs';
import { List as List$1 } from './model/List.mjs';
import { ListFilter } from './setupComponents/ListFilter.mjs';
import { ListItem } from './setupComponents/ListItem.mjs';
import { ListLoaderAsync } from './setupComponents/ListLoaderAsync.mjs';
import { ListLoaderAsyncResource } from './setupComponents/ListLoaderAsyncResource.mjs';
import { ListSearch } from './setupComponents/ListSearch.mjs';
import { ListSorting } from './setupComponents/ListSorting.mjs';
import { ListStaticData } from './setupComponents/ListStaticData.mjs';
import { Table as Table$1 } from './setupComponents/Table.mjs';
import { TableBody } from './setupComponents/TableBody.mjs';
import { TableCell } from './setupComponents/TableCell.mjs';
import { TableColumn } from './setupComponents/TableColumn.mjs';
import { TableHeader } from './setupComponents/TableHeader.mjs';
import { TableRow } from './setupComponents/TableRow.mjs';
import { flowComponent } from '../../lib/componentFactory/flowComponent.mjs';
import '../../lib/propsContext/propsContext.mjs';
import 'react';
import '../../lib/viewComponentContext/viewComponentContext.mjs';
import { PropsContextProvider } from '../../lib/propsContext/PropsContextProvider.mjs';
import { deepFindOfType, deepFilterByType } from '../../lib/react/deepFindOfType.mjs';
import DivView from '../../views/DivView.mjs';
import { TunnelProvider, TunnelExit } from '@mittwald/react-tunnel';
import { Footer } from './components/Footer/Footer.mjs';
import styles from './List.module.css.mjs';
import { listContext } from './listContext.mjs';

const List = flowComponent("List", (props) => {
  const { children, batchSize, onChange, ref, hidePagination, ...restProps } = props;
  const listLoaderAsync = deepFindOfType(
    children,
    ListLoaderAsync
  )?.props;
  const listLoaderAsyncResource = deepFindOfType(
    children,
    ListLoaderAsyncResource
  )?.props;
  const listStaticData = deepFindOfType(children, ListStaticData)?.props;
  const loaderShape = {
    source: listLoaderAsync ? {
      ...listLoaderAsync,
      asyncLoader: listLoaderAsync.children
    } : listLoaderAsyncResource ? {
      ...listLoaderAsyncResource,
      asyncResourceFactory: listLoaderAsyncResource.children
    } : listStaticData ? {
      staticData: listStaticData.data
    } : void 0
  };
  const searchProps = deepFindOfType(children, ListSearch)?.props;
  const itemViewProps = deepFindOfType(children, ListItem)?.props;
  const tableProps = deepFindOfType(children, Table$1)?.props;
  const tableColumnProps = deepFilterByType(children, TableColumn).map(
    (c) => ({
      ...c.props,
      name: c.props.children
    })
  );
  const tableCellProps = deepFilterByType(children, TableCell).map(
    (c) => ({
      ...c.props,
      renderFn: c.props.children
    })
  );
  const tableRowProps = deepFindOfType(children, TableRow)?.props;
  const tableHeaderProps = deepFindOfType(children, TableHeader)?.props;
  const tableBodyProps = deepFindOfType(children, TableBody)?.props;
  const listModel = List$1.useNew({
    onChange,
    loader: loaderShape,
    filters: deepFilterByType(children, ListFilter).map(
      (f) => ({
        ...f.props,
        renderItem: f.props.children
      })
    ),
    search: searchProps ? {
      render: searchProps.children,
      textFieldProps: searchProps,
      defaultValue: searchProps.defaultValue
    } : void 0,
    sorting: deepFilterByType(children, ListSorting).map((s) => s.props),
    itemView: itemViewProps ? {
      ...itemViewProps,
      renderFn: itemViewProps.children
    } : void 0,
    table: tableColumnProps.length > 0 ? {
      header: {
        ...tableHeaderProps,
        columns: tableColumnProps
      },
      body: {
        ...tableBodyProps,
        row: {
          ...tableRowProps,
          cells: tableCellProps
        }
      },
      ...tableProps
    } : void 0,
    batchesController: {
      batchSize
    },
    ...restProps
  });
  const propsContext = {
    ActionGroup: {
      tunnelId: "actions",
      className: headerStyles.actions,
      Button: {
        className: headerStyles.action
      }
    },
    ListSummary: {
      tunnelId: "listSummary"
    }
  };
  return /* @__PURE__ */ jsx(PropsContextProvider, { props: propsContext, children: /* @__PURE__ */ jsx(TunnelProvider, { children: /* @__PURE__ */ jsxs(
    listContext.Provider,
    {
      value: {
        list: listModel
      },
      children: [
        /* @__PURE__ */ jsx(DataLoader, {}),
        /* @__PURE__ */ jsxs(DivView, { className: styles.list, ref, children: [
          children,
          /* @__PURE__ */ jsx(Header, {}),
          /* @__PURE__ */ jsxs(DivView, { className: styles.listWrapper, children: [
            listModel.items.entries.length > 0 && /* @__PURE__ */ jsx(TunnelExit, { id: "listSummary" }),
            (listModel.viewMode === "list" || listModel.viewMode === "tiles") && /* @__PURE__ */ jsx(Items, {}),
            listModel.viewMode === "table" && /* @__PURE__ */ jsx(Table, {})
          ] }),
          !hidePagination && /* @__PURE__ */ jsx(Footer, {})
        ] })
      ]
    }
  ) }) });
});

export { List, List as default };
//# sourceMappingURL=List.mjs.map
